import { Children, type ReactNode } from "react";
import { cx } from "../cx";

/** Mono facts separated by middle dots: "+14 −6 · footnotes 2 · figures 1". */
export function StatLine({
  items,
  className = "",
}: {
  items: ReadonlyArray<ReactNode>;
  className?: string;
}) {
  return (
    <p
      data-component="StatLine"
      className={cx("m-0 flex flex-wrap items-center font-mono text-label text-ink-2", className)}
    >
      {Children.map(items, (item, i) => (
        <span className="flex items-center">
          {i > 0 ? (
            <span aria-hidden="true" className="px-1.5">
              ·
            </span>
          ) : null}
          {item}
        </span>
      ))}
    </p>
  );
}
